module.exports = __webpack_public_path__ + "static/media/danielle_cristina_de_morais_amorim.4e13149f.jpg";